import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=53ed1944&scoped=true&"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&id=53ed1944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed1944",
  null
  
)

export default component.exports